import { Component, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { LABEL_PARAMS } from '../label-list/label-list.component';
import { LabelService } from '../label.service';
import { Label } from '../model/label';

@Component({
    selector: 'app-edit-label-modal',
    templateUrl: './edit-label-modal.component.html',
    styleUrls: ['./edit-label-modal.component.scss'],
})
export class EditLabelModalComponent implements OnInit {
    label: Partial<Label>;
    orderId: string;
    createdLabel$ = new Subject<void>();
    close$ = new Subject<void>();
    selectedColour: number = 0;

    labelTextControl: FormControl;
    colours = ['tomato', 'orange', 'dodgerblue', 'gray', 'violet', 'lightgray'];

    constructor(private labelService: LabelService, @Inject(LABEL_PARAMS) public params: any) {}

    ngOnInit(): void {
        this.label = this.params.label;
        this.orderId = this.params.orderId;
        this.labelTextControl = new FormControl(this.label.name, [Validators.required]);
        const foundColour = this.colours.map((item) => item.toLowerCase()).indexOf(this.label?.colour?.toLowerCase());

        if (foundColour !== -1) {
            this.selectedColour = foundColour;
        }
    }

    selectLabelColour(i) {
        this.selectedColour = i;
    }

    onSubmit() {
        if (!this.label.id) {
            const colour = this.colours[this.selectedColour];
            this.labelService
                .createLabel({
                    name: this.labelTextControl.value,
                    colour: colour,
                    type: this.params.label.type,
                })
                .pipe(
                    concatMap((createdLabel: Label) => {
                        return this.labelService.assignLabel(createdLabel.id, this.orderId);
                    })
                )
                .subscribe(() => this.createdLabel$.next());
        } else {
            this.labelService
                .editLabel({
                    name: this.labelTextControl.value,
                    colour: this.colours[this.selectedColour],
                    id: this.label.id,
                    type: this.params.label.type,
                })
                .subscribe(() => this.createdLabel$.next());
        }
    }
}
